exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cust-col {\n  padding-left: 12px;\n  padding-right: 12px; }\n\n.busy *:not(.submit-warn) {\n  opacity: 0.5;\n  z-index: 9999; }\n\n.overlay {\n  position: relative; }\n\nimg.busySpin {\n  margin-top: 48px;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: 96px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/shifts-recon/components/form-core-shift/form-core-shift.component.scss
// module id = ../../../../../src/app/views/daily-recon/shifts-recon/components/form-core-shift/form-core-shift.component.scss
// module chunks = main